import { Layout, Menu, Modal } from "antd";
import * as React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { BaPingModals } from './baPingModals';
import './index.less';
// import {loopRequestVersion} from './version'
import classNames from 'classnames';
import kecheng from '../../../assets/images/kecheng.png';
import { MenuClassName } from './menuIcon';
import { setMenuTag } from './menuTag';
// import logo from '../../../assets/images/logo.png'
import { doPostRequest } from '@/tools/axios_';
import { Utils, getToken } from '@/tools/utils';
import { addPolicies } from '@lima/seraphim-react';
import md5 from 'md5';
import { axios_, doGetRequest } from '../../../tools/axios_';
import './index.less';
// import Agreement from '../../agreement/agreement';
// import ConfirmPhone from '../../confirm-phone/confirm-phone';
import { getControlChannelRoots, getIsDepartmentOrg, getUserPermissionInfoByCodeNoBff } from '@/component/companymanager/ChannelManager/services';
import { accountIsMyself, changeChannelType, changeDepartmentOrgType } from '@/component/login/action';
import store from '@/store';
import sensors from '../../../tools/sensors/autoTrack';
import { MERCHANT_NAVIGATION_CLICK } from "../../../tools/sensors/enum";
import { getUserPermissionInfo } from "../../system/api/roleManage";
import FunctionUpgrade from '../function-upgrade';
import ProductLaunch from '../product-launch';
import SubscribeModal from '../subscribe-modal';
import { ActivityManagerIcon, BusinesCountIcon, ContinueRateIcon, CustomIcon, FeePromotionIcon, HomePageIcon, MallIcon, MoneySettlementIcon, OrganizationIcon, PolicyManagerIcon, ProductIcon, SettingIcon, ToolMarketIcon, ZhanyeEndIcon } from './menu_icon';
import { checkMenuPermission } from "./permissions";
// import { object } from 'prop-types';
// import logoHlb from '../../../assets/images/hlb_menu_logo.png'

const { Sider } = Layout;
const SubMenu = Menu.SubMenu;
let defaultOpenKeys = ['index'];
let defaultSelectedKeys = ['index'];
let rootSubmenuKeys = [];
const ignorePermissions = [];
const MenuSensorsType = {
    '机构管理': 'MerchantMenuOrganizationInstitutionClick',
    '团队管理': 'MerchantMenuOrganizationTeamClick',
    '业务员管理': 'MerchantMenuOrganizationSalesmanClick',
};
class Left extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: document.body.clientWidth < 980,
            currentPath: null,
            menuList: [],//菜单列表  从后台获取
            selectedKeys: ['index'],
            openKeys: ['index'],
            isStaging: false,
            agreementVisiable: false,
            confirmPhoneVisiable: false,
            isAdmin: sessionStorage.getItem('permission') == 'admin',//是否为超管账号，如果是则显示灰色主题；否则
            loginType: '',
            userAgreementState: true,
            subscribeModalVisible: false,
            qrCodeUrl: '',
            qrCodeId: '',
            showBaPing: true,
            isFirst: false,
            flag: true,   //   关注公众号二维码接口，返回异常时不再调用
            isDepartmentOrg: 0, // 1 自媒体商户
            productLaunch: false,
            functionUpgrade: false,
            productList: []
        };
    }

    qrcodeStatusTimer = null;

    /** 生命*/
    componentWillReceiveProps(nextProps) {
        if (nextProps.location.pathname === '/homePage' || nextProps.location.pathname.indexOf('system') > -1) {
            defaultOpenKeys = ['index'];
            defaultSelectedKeys = ['index'];
        }
        this.setHeighLight(nextProps.location.pathname);
    }

    async componentDidMount() {
        this.setState({
            currentPath: this.props.pathName,
            isStaging: window.location.hostname.includes('-uat'),
        });
        this.isGuideRead();
        this.getControlChannel();
        this.getMenus();
        setTimeout(() => {
            this.getUserPermissionInfo();
        }, 100);
        localStorage.setItem('tenant_pc', 'tenant_pc');
        // loopRequestVersion();
    }

    async shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (Utils.getUserId() && Utils.getCompanyLevelId() === '10005' && !Utils.isHLB() && nextState.flag) {
            this.setState({
                flag: false,
            });
            await this.querySubscribeQrCode();
            return true;
        }
        return false;
    }

    componentWillUnmount() {
        this.qrcodeStatusTimer && clearInterval(this.qrcodeStatusTimer);
    }

    getControlChannel = async()=>{
        const res = await getControlChannelRoots()
        const channelStatus = res.status === 200 && res.data
        store.dispatch(changeChannelType(channelStatus));
        const resDepartment = await getIsDepartmentOrg();
        const {isDepartmentOrgFlag} = resDepartment.status === 200 && resDepartment.data;
        this.setState({
            isDepartmentOrg: isDepartmentOrgFlag,
        });
        store.dispatch(changeDepartmentOrgType(isDepartmentOrgFlag));
        const resp = await getUserPermissionInfoByCodeNoBff({ userId: Utils.getUserId(), permissionCode: '151_001' });
        store.dispatch(accountIsMyself(resp.data.dataPermission));
    }

    getMenus = () => {
        axios_({
            url: 'getUserAuthTree',
            method: 'get',
            headers: {
                'access-token': this.props.token,
            },
        }).then(res => {
            checkMenuPermission(res.data || []).then(menuList => {
                this.setState({ menuList }, () => {
                    this.setHeighLight(this.props.pathName);
                    this.props.dispatch({ type: "ADD_MENU_ID", list: (function formatId(arr) { let cs = []; let ids = arr.reduce((last, next) => { last.push(next.id); if (next.children && next.children.length) { cs.push(...formatId(next.children)); }; return last }, []); ids.push(...cs); return ids })(menuList) })

                });
            })
        }).catch(e => {

        });
    }
    //获取用户按钮权限
    getUserPermissionInfo() {
        getUserPermissionInfo({ userId: Utils.getUserId() }).then(res => {
            if (res.status === 200) {
                addPolicies(Object.keys(res.data.functionPermissionInfo).concat(ignorePermissions).filter((v) => v));
            }
        }).catch(e => {

        });
    }
    /**
     * 设置高亮
     */
    setHeighLight(_pathName) {
        //defaultSelectedKeys 这个默认的选中状态 只渲染一次 所以再渲染前 取过来选中的项目
        if (this.state.menuList.length) {
            this.state.menuList.forEach((parentItem) => {
                if (parentItem.children.length) {
                    parentItem.children.forEach((item) => {
                        if (_pathName.indexOf(item.path) > -1) {
                            //取到当前页面的地址
                            if (_pathName.indexOf('/company/companyManager/prodControl') > -1) {
                                defaultOpenKeys = ['' + item.parentId];
                            } else {
                                defaultOpenKeys = ['' + item.parentId];
                                defaultSelectedKeys = ['' + item.id];
                            }

                        }
                    });
                } else {
                    if (_pathName.indexOf(parentItem.path) > -1) {
                        //取到当前页面的地址
                        if (_pathName.indexOf('/company/companyManager/prodControl') > -1) {
                            defaultOpenKeys = ['' + parentItem.parentId];
                        } else {
                            defaultOpenKeys = ['' + parentItem.parentId];
                            defaultSelectedKeys = ['' + parentItem.id];
                        }

                    }
                }
            });
        }
        this.setState({
            selectedKeys: defaultSelectedKeys,
            openKeys: defaultOpenKeys,
        });

        rootSubmenuKeys = this.state.menuList && this.state.menuList.length > 0 && this.state.menuList.map(ele => {
            return ele.id + '';
        });
    }


    onOpenChange = (openKeys) => {
        // this.setState({
        //   openKeys
        // })
        // const rootSubmenuKeys = this.state.menuList.map(ele => {return ele.id + ''});
        const latestOpenKey = openKeys.filter(key => this.state.openKeys.indexOf(key) === -1);
        if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            this.setState({ openKeys });
        } else {
            this.setState({
                openKeys: latestOpenKey ? [latestOpenKey] : [],
            });
        }
    };

    // 过滤埋点的目录
    filterSensors(key) {
        if (MenuSensorsType[key]) {
            return MenuSensorsType[key];
        } else {
            return false;
        }
    }

    // 目录点击埋点
    handleMenuWithSensor = (item) => {
        const children = item.props?.children?.props?.children;
        if (children && children.length > 0 && typeof children[0] === 'string' && this.filterSensors(children[0])) {
            const sensorsName = this.filterSensors(children[0]);
            sensors.track(sensorsName);
        }
    };

    onSelect = ({ item, selectedKeys }) => {
        //预核保记录
        if (item.props.children.props?.to === '/proposalSys/preUnderwritingRecord') {
            sensors.track('MerchantNavigationClick', {
                "element_content": "订单管理-预核保记录",
            });
        }
        this.handleMenuWithSensor(item);

        this.setState({
            selectedKeys,
        }, () => {
        });
    };
    renderMenuIcon= (name) => {
        switch (name) {
            case 'icon-zuzhijiagou_export':
                return <OrganizationIcon style={this.state.isDepartmentOrg !== 1 ?{fill: 'currentColor',color: '#fff'}: null}/>;
            case 'icon-chanpinguanli_export':
                return <ProductIcon style={this.state.isDepartmentOrg !== 1 ?{fill: 'currentColor',color: '#fff',marginRight: 10}: { marginRight: 10 }}/>;
            case 'icon-tuiguangfei':
                return <FeePromotionIcon style={this.state.isDepartmentOrg !== 1 ?{fill: 'currentColor',color: '#fff'}: null}/>;
            case 'icon-huodongguanli':
                return <ActivityManagerIcon style={this.state.isDepartmentOrg !== 1 ?{fill: 'currentColor',color: '#fff'}: null}/>;
            case 'icon-baodanyangben_export':
                return <PolicyManagerIcon style={this.state.isDepartmentOrg !== 1 ?{fill: 'currentColor',color: '#fff'}: null}/>;
            case 'icon-shangchengmoban_export':
                return <ZhanyeEndIcon style={this.state.isDepartmentOrg !== 1 ?{fill: 'currentColor',color: '#fff'}: null}/>;
            case 'icon-baobiao_export':
                return <BusinesCountIcon style={this.state.isDepartmentOrg !== 1 ? {fill: 'currentColor',color: '#fff'} : null}/>;
            case 'icon-zhexiantu-xianxing':
                return <ContinueRateIcon style={this.state.isDepartmentOrg !== 1 ?{fill: 'currentColor',color: '#fff'}: null}/>;
            case 'icon-gongjushichang':
                return <ToolMarketIcon style={this.state.isDepartmentOrg !== 1 ?{fill: 'currentColor',color: '#fff'}: null}/>;
            case 'icon-caiwu_export':
                return <MoneySettlementIcon style={this.state.isDepartmentOrg !== 1 ?{fill: 'currentColor',color: '#fff'}: null}/>;
            case 'icon-shangchengguanli':
                return <MallIcon style={this.state.isDepartmentOrg !== 1 ?{fill: 'currentColor',color: '#fff'}: null}/>;
            case 'icon-kehuguanli':
                return <CustomIcon style={this.state.isDepartmentOrg !== 1 ?{fill: 'currentColor',color: '#fff'}: null}/>;
            case 'icon-xitongguanli':
                return <SettingIcon style={this.state.isDepartmentOrg !== 1 ?{fill: 'currentColor',color: '#fff'}: null}/>;
            default:
                break;
        }
    }
    createMenu = (menuList) => {
        return menuList.map(menu => {
            if (menu.children.length) {
                return (
                    <SubMenu key={menu.id + ''} title={
                        <span style={{ display: 'flex', alignItems: 'center' }}                            >
                            {/* {
                                menu.parentId === '-1' && <i style={{ marginRight: 10 }} className={`iconfont ${menu.icon}`} />
                            } */}
                            {
                                menu.parentId === '-1' && this.renderMenuIcon(menu.icon)
                            }
                            <span>{menu.label}</span>
                            {/* `菜单展示图标`,针对一些特定菜单进行展示 */}
                            <i style={{ marginLeft: 10 }} className={classNames('iconfont', MenuClassName(menu))} />
                        </span>
                    }
                        data={menu}
                    >
                        {this.createMenu(menu.children)}
                    </SubMenu>
                )
            } else {
                return <Menu.Item key={menu.id + ""} style={{ color: "black" }} className={menu.className || ''} >
                    <Link style={{ display: 'flex', alignItems: 'center' }} replace to={menu.path || '/'} onClick={() => {
                        MERCHANT_NAVIGATION_CLICK[menu.path] && Utils.customTrack('MerchantNavigationClick', {
                            element_content: MERCHANT_NAVIGATION_CLICK[menu.path]
                        });
                    }}>
                        {
                            menu.parentId === '-1' && this.renderMenuIcon(menu.icon)
                        }
                        {/* {
                            menu.parentId === '-1' && <i style={{ marginRight: 10 }} className={`iconfont ${menu.icon}`} />
                        } */}
                        {menu.title}
                        {/* {menu.parentId !== '-1' && menu.icon && <i style={{ marginLeft: 10 }} className={`iconfont ${menu.icon}`} />} */}
                        {setMenuTag(menu) && <i style={{ marginLeft: 10 }} className={`iconfont menu_icon_aboriginal_online_tag`} />}
                    </Link>
                </Menu.Item>
            }
        });
    };

    changePhone = () => {
        window.localStorage.removeItem('loginType');
        this.setState({ confirmPhoneVisiable: false });
    };

    querySubscribeQrCode = async () => {
        const subscribeWechat = localStorage.getItem('subscribeWechat');
        try {
            const { data } = await doGetRequest({
                url: '/api/organization/wechat/admin/bindQrCode',
                params: {
                    userId: Utils.getUserId(),
                },
            });

            if (!!data.qrCodeUrl && subscribeWechat !== 'true') {
                this.setState({
                    qrCodeUrl: data.qrCodeUrl,
                    qrCodeId: data.qrCodeId,
                    subscribeModalVisible: true,
                }, () => {
                    data.qrCodeId && this.setQrcodeStatusTimer();
                })
            } else {
                this.setState({
                    subscribeModalVisible: false,
                }, () => { this.showOtherModal() })
            }
            localStorage.setItem('subscribeWechat', 'true');
        } catch (error) {

        }

    };

    setQrcodeStatusTimer = () => {
        this.qrcodeStatusTimer === null && (this.qrcodeStatusTimer = setInterval(() => {
            this.getQrcodeStatus();
        }, 1000));
    };

    getQrcodeStatus = async () => {
        const { data } = await doGetRequest({
            url: `/api/organization/wechat/subscribe/qrCode/${this.state.qrCodeId}`
        });
        if (data.status === 'SUCCESS') {
            !this.state.isFirst && Utils.customTrack('MerchantTencentisuxQuickMark');
            this.setState({
                isFirst: true,
            });
        }
        if (data.status !== 'NEW') {
            this.setState({ subscribeModalVisible: false }, () => {
                this.showOtherModal();
            })
        }
    };

    closeQrcodeModal = () => {
        this.setState({ subscribeModalVisible: false }, () => {
            this.showOtherModal()
        })
    };

    showOtherModal = () => {
        this.qrcodeStatusTimer && clearInterval(this.qrcodeStatusTimer);
        this.setState({
            showBaPing: true,
        });
    }
    closeFalse =()=>{
        this.setState({
            productLaunch: false
        })
    }
    isGuideRead = async() => {
        this.setState({
            functionUpgrade: false
        })
        const res = await doGetRequest({
            url: '/api/market/product/v1/noviceGuidance',
            params: {
                agencyId: Utils.getOrgId(),
                basicKey: '20241217-batch6'
            }
        })
        if (res.status === 200) {
            if(res.data ===1){
                let PlatformUpgrade =window.localStorage.getItem('PlatformRepository');
                let newToken = md5(getToken()+ Utils.getOrgId());
                setTimeout(() => {
                    console.log(Utils.getUserId());
                    if(Utils.getUserId() && Utils.getCompanyLevelId() === '10005' && !PlatformUpgrade && (PlatformUpgrade !== newToken)){
                        this.getUnSigningList();
                    }
                }, 500);

            }else{
                this.setState({
                    functionUpgrade: res.data === 0
                })
            }

        }
    }
    getUnSigningList = async()=>{
        try {
            const { data } = await doPostRequest({
                url: '/api/cls/company/product/getUnSigningList',
                data: {
                    orgId: Utils.getOrgId()
                },
            });
            if(data && data.length>0){
                this.setState({
                    productLaunch: true,
                    productList: data
                })
                window.localStorage.setItem('PlatformRepository',md5(getToken()+ Utils.getOrgId()));
            }
        } catch (error) {

        }
    }
    successHandle=()=>{
        Modal.success({
            title: "已确认",
            content:"所有产品已可正常展业"
        })
        this.setState({
            productLaunch: false
        })
    }
    render() {
        const {
            menuList,
            // collapsed
        } = this.state;
        // console.log(this)
        return (
            <div
                className={['left_bar', (Utils.isHLB() || this.state.isDepartmentOrg === 1) ? 'hlb' : null].join(' ')}
                style={{
                    overflowY: 'auto',
                    width: 250
                }}>
                <Sider
                    trigger={null}
                    collapsible
                    theme={(Utils.isHLB() || this.state.isDepartmentOrg === 1) ? 'light' : 'dark'}
                    // theme={'light'}
                    style={{
                        maxWidth: '250px !important'
                    }}
                >
                    <div className="logo">
                        {
                            this.state.isStaging ? <img className="logo_img_kecheng" alt="力码科技"
                                src={kecheng} /> : (
                                this.props.userInfo.logoUrl && <img className="logo_img_lima" alt="力码科技"
                                    src={this.props.userInfo.logoUrl} />
                            )
                        }
                    </div>
                    {menuList.length > 0 && (<Menu
                        mode="inline"
                        theme={(Utils.isHLB() || this.state.isDepartmentOrg === 1) ? 'light' : 'dark'}
                        defaultOpenKeys={defaultOpenKeys}
                        defaultSelectedKeys={defaultSelectedKeys}
                        selectedKeys={this.state.selectedKeys}
                        openKeys={this.state.openKeys}
                        onOpenChange={this.onOpenChange}
                        onSelect={this.onSelect}
                    >
                        <Menu.Item key="index" className="shouye_item">
                            {/* <Link to="/homePage" onClick={() => {
                                MERCHANT_NAVIGATION_CLICK['/homePage'] && Utils.customTrack('MerchantNavigationClick', {
                                    element_content: MERCHANT_NAVIGATION_CLICK['/homePage']
                                });
                            }}><i style={{ marginRight: 10 }} className={`iconfont icon-home`} />首页</Link> */}
                            <Link to="/homePage" onClick={() => {
                                MERCHANT_NAVIGATION_CLICK['/homePage'] && Utils.customTrack('MerchantNavigationClick', {
                                    element_content: MERCHANT_NAVIGATION_CLICK['/homePage']
                                });
                            }}><HomePageIcon style={this.state.isDepartmentOrg !== 1 ?{fill: 'currentColor',color: '#fff',marginRight: 10}: { marginRight: 10,}} className="shouye_item_icon"/>首页</Link>
                        </Menu.Item>

                        {
                            this.createMenu(menuList)
                        }
                    </Menu>)}
                </Sider>

                {/*<Agreement visiable={this.state.agreementVisiable}*/}
                {/*           onClose={() => this.setState({agreementVisiable: false})} type={'home'}*/}
                {/*           token={this.props.token}/>*/}
                {/*<ConfirmPhone visiable={this.state.confirmPhoneVisiable} onConfirm={() => this.changePhone()}*/}
                {/*              token={this.props.token}/>*/}
                {this.state.showBaPing && <BaPingModals
                    {...this.props}
                />}
                {this.state.subscribeModalVisible && <SubscribeModal
                    visible={this.state.subscribeModalVisible}
                    changeVisible={this.closeQrcodeModal}
                    qrCodeUrl={this.state.qrCodeUrl}
                    qrCodeId={this.state.qrCodeId}
                />}
                <FunctionUpgrade
                visible={this.state.functionUpgrade}
                onCancel={_=> this.isGuideRead()}></FunctionUpgrade>
                <ProductLaunch
                    visible={this.state.productLaunch}
                    productList={this.state.productList}
                    onSuccess = {_=> this.successHandle()}
                    onCancel ={_=> this.closeFalse()}></ProductLaunch>


                {/* {Utils.getUserData().mobilePhone && localStorage.getItem("passGuide" + Utils.getUserData().mobilePhone) != "1" && <Guide />} */}
            </div>
        );
    }
}

function mapState(state) {
    return {
        userInfo: state.userInfo,
        token: state.token,
        pathName: state.pathName,
    };
}

export default withRouter(connect(mapState)(Left));
